export const palette = {
  greenMain: "#385A52",
  greenMainLight: "rgba(56,90,82,0.6)",
  greenSecond: "#b9cbcb",
  orange: "#EF8E02",
  orangeTwo: "#F58220",
  white: "#FFFFFF",
  boxShadowCard: "0px 3px 3px #00000029",
  dangerColor: "#b71616",
  textGreenTitle: "#014d43",
  secondaryTextColor: "#464655",
  ultraPale: "rgb(249, 249, 249)",
  greyFont: "#555555",
  grenTitle: "#003D53",
  // Overlays and shadows
  overlayDark: "rgba(0, 0, 0, 0.5)",
  overlayLight: "rgba(0, 0, 0, 0.3)",
  overlayWhite: "rgba(255, 255, 255, 0.95)",
  shadowLight: "rgba(0, 0, 0, 0.1)",
  shadowMedium: "rgba(0, 0, 0, 0.15)",
  shadowDark: "rgba(0, 0, 0, 0.2)",
  shadowStrong: "rgba(0, 0, 0, 0.4)",
};
